import type { FaireProductEntity } from "../../entity_types/product";

export const p_3yquy5v9f2: FaireProductEntity = {
  token: "p_3yquy5v9f2",
  type: "product",
  name: "TF26-0489 - Stripe boatneck knit midi dress",
  brandToken: "b_jejdgbfw35",
  brandName: "Twentifourth",
  imageUrl:
    "https://cdn.faire.com/fastly/b2381cc8f1c8b939baaee34b05771967c7eec828e602a752543ee088e8279a29.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/d6152cd10b59c6cd66e1cdb84a99e28a012cabc0d42b76eed76a0c285895f86d.jpeg",
    "https://cdn.faire.com/fastly/173ac6505cd4cff658d2f924cc873fc7bc07414689ece728546ebc4cefcfb685.jpeg",
  ],
  priceDollars: 28.55,
  description:
    "* Style No.: TF26-0489\n\nLong sleeve boat neck stripe midi knit dress\n\n",
  tags: [],
  msrpDollars: 57.1,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-07-23T06:19:49.086Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
